// Environment configuration
export interface AppConfig {
  apiBaseUrl: string
  appTitle: string
  environment: 'development' | 'production'
  isDevelopment: boolean
  isProduction: boolean
}

// Get environment variables with fallbacks
const getEnvVar = (key: string, fallback: string): string => {
  return import.meta.env[key] || fallback
}

// Determine API base URL based on environment
const getApiBaseUrl = (): string => {
  // Check if we have environment variable
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }

  // Auto-detect based on current location
  const currentOrigin = window.location.origin

  // Development detection
  if (currentOrigin.includes('localhost:5173') || currentOrigin.includes('127.0.0.1:5173')) {
    return 'http://localhost:5062'
  }

  // Production - assume API is on the same domain
  return currentOrigin
}

// Create configuration object
export const config: AppConfig = {
  apiBaseUrl: getApiBaseUrl(),
  appTitle: getEnvVar('VITE_APP_TITLE', 'Trafix Admin Panel'),
  environment: getEnvVar('VITE_APP_ENV', 'development') as 'development' | 'production',
  isDevelopment: getEnvVar('VITE_APP_ENV', 'development') === 'development',
  isProduction: getEnvVar('VITE_APP_ENV', 'development') === 'production',
}

// Export individual values for convenience
export const API_BASE_URL = config.apiBaseUrl
export const APP_TITLE = config.appTitle
export const IS_DEVELOPMENT = config.isDevelopment
export const IS_PRODUCTION = config.isProduction

// Debug logging removed for production
